import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Scan, Loader2 } from 'lucide-react';

export function ScanBar({ inputRef, onScan, loading, highlight = false }: {
  inputRef: React.RefObject<HTMLInputElement | null>;
  onScan: (code: string) => void;
  loading: boolean;
  /** Destaca el cuadro (agrandado + anillo) al volver desde el flujo de bolsa. */
  highlight?: boolean;
}) {
  const { t } = useTranslation();
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim()) { onScan(code); setCode(''); }
  };

  return (
    <form onSubmit={handleSubmit}
      className={`bg-[var(--color-bg-card)] border-2 border-[var(--color-primary)] rounded-xl p-4 flex items-center gap-4 transition-all duration-300 ${
        highlight
          ? 'scale-[1.03] ring-4 ring-[var(--color-primary)]/40 shadow-lg'
          : 'scale-100'
      }`}
    >
      <Scan size={28} className="text-[var(--color-primary)] shrink-0" />
      <input
        ref={inputRef}
        type="text"
        value={code}
        onChange={e => setCode(e.target.value)}
        placeholder={t('wh.scanTracking')}
        className="flex-1 bg-transparent text-[var(--color-text)] placeholder:text-[var(--color-text-secondary)] text-lg font-mono outline-none"
        autoFocus
      />
      <button type="submit" disabled={loading || !code.trim()}
        className="px-6 py-3 bg-[var(--color-primary)] text-white rounded-xl text-lg font-semibold disabled:opacity-50"
      >
        {loading ? <Loader2 size={20} className="animate-spin" /> : t('wh.scan')}
      </button>
    </form>
  );
}
